<template>
  <div class="job-apply-confirmation">
    <div :id="modalId" :class="{ 'is-active': modalId }" class="modal">
      <div class="modal-background columns is-flex is-vcentered">
        <div class="modal-content column is-one-third">
          <div class="box">
            <div class="modal-head">
              <h2>
                <b>{{ $t('Confirmation') }}</b>
              </h2>
              <hr class="mt-2" />
            </div>
            <div class="content">
              <p>{{ $t('AreYouSureDoYouWantToApply') }}</p>
            </div>
            <div class="btns has-text-right">
              <button class="button px-5" @click="closePopup()">
                {{ $t('No') }}
              </button>
              <button
                id="apply-confirmed"
                class="button is-success px-5"
                @click="confirmedApply(selectedJob)"
              >
                {{ $t('Yes') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedJob: {
      type: Object,
      default: null
    },
    modalId: {
      type: Number,
      default: null
    }
  },
  methods: {
    closePopup() {
      const modal = document.getElementById(`${this.modalId}`)
      modal.style.display = 'none'
      this.$emit('close')
    },
    confirmedApply(selectedJob) {
      // called parent component method from child component
      this.$parent.applyJob(selectedJob)
    }
  }
}
</script>
